"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.commonTranslationMessages = react_intl_1.defineMessages({
    taxCategoryType_labels_StandardRated: {
        id: "taxCategoryType_labels_StandardRated",
        defaultMessage: "Standard rated",
    },
    taxCategoryType_labels_ReducedRated: {
        id: "taxCategoryType_labels_ReducedRated",
        defaultMessage: "Reduced rated",
    },
    taxCategoryType_labels_ZeroRated: {
        id: "taxCategoryType_labels_ZeroRated",
        defaultMessage: "Zero rated",
    },
    taxCategoryType_labels_Exempt: {
        id: "taxCategoryType_labels_Exempt",
        defaultMessage: "Exempt",
    },
    taxCategoryType_labels_OutsideTaxScope: {
        id: "taxCategoryType_labels_OutsideTaxScope",
        defaultMessage: "Outside tax scope",
    },
    taxCategoryType_labels_ReverseCharged: {
        id: "taxCategoryType_labels_ReverseCharged",
        defaultMessage: "Reverse charged",
    },
    taxCategoryType_labels_FreeExportTaxNotCharged: {
        id: "taxCategoryType_labels_FreeExportTaxNotCharged",
        defaultMessage: "Free export tax not charged",
    },
    taxCategoryType_labels_ExemptEuropeanEconomicArea: {
        id: "taxCategoryType_labels_ExemptEuropeanEconomicArea",
        defaultMessage: "Exempt European economic area",
    },
    unitOfMeasure_labels_Piece: {
        id: "unitOfMeasure_labels_Piece",
        defaultMessage: "Piece",
    },
    unitOfMeasure_labels_Kilogram: {
        id: "unitOfMeasure_labels_Kilogram",
        defaultMessage: "Kilogram",
    },
    unitOfMeasure_labels_Month: {
        id: "unitOfMeasure_labels_Month",
        defaultMessage: "Month",
    },
    unitOfMeasure_labels_Package: {
        id: "unitOfMeasure_labels_Package",
        defaultMessage: "Package",
    },
    unitOfMeasure_labels_Year: {
        id: "unitOfMeasure_labels_Year",
        defaultMessage: "Year",
    },
    unitOfMeasure_labels_Day: {
        id: "unitOfMeasure_labels_Day",
        defaultMessage: "Day",
    },
    unitOfMeasure_labels_Hour: {
        id: "unitOfMeasure_labels_Hour",
        defaultMessage: "Hour",
    },
    unitOfMeasure_labels_Kilometre: {
        id: "unitOfMeasure_labels_Kilometre",
        defaultMessage: "Kilometre",
    },
    unitOfMeasure_labels_Metre: {
        id: "unitOfMeasure_labels_Metre",
        defaultMessage: "Metre",
    },
    unitOfMeasure_labels_Litre: {
        id: "unitOfMeasure_labels_Litre",
        defaultMessage: "Litre",
    },
    unitOfMeasure_labels_SquareMetre: {
        id: "unitOfMeasure_labels_SquareMetre",
        defaultMessage: "Square metre",
    },
    unitOfMeasure_labels_CubicMetre: {
        id: "unitOfMeasure_labels_CubicMetre",
        defaultMessage: "Cubic metre",
    },
    unitOfMeasure_labels_Tonne: {
        id: "unitOfMeasure_labels_Tonne",
        defaultMessage: "Tonne",
    },
    unitOfMeasure_labels_KiloWattHour: {
        id: "unitOfMeasure_labels_KiloWattHour",
        defaultMessage: "KiloWatt hour",
    },
    unitOfMeasure_labels_One: {
        id: "unitOfMeasure_labels_One",
        defaultMessage: "One",
    },
});
